import TicketTiersContent from '../../TicketTiersContent';

const TicketTiersStep = () => <TicketTiersContent showSpecialCodeForm />;

export default TicketTiersStep;
